(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ezonzy-final-cta"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Smooth-scroll the in-page button to the pack cards instead of jumping.
    document.addEventListener('click', function (e) {
      var link = e.target.closest && e.target.closest('.ezc__btn[href^="#"]');
      if (!link) return;
      var target = document.getElementById(link.getAttribute('href').slice(1));
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ezonzy-honey-landing-before-review-20261021"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    var timers = {};

    function qs(el, s) { return el.querySelector(s); }
    function qsa(el, s) { return Array.prototype.slice.call(el.querySelectorAll(s)); }
    function esc(str) {
      return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    function money(cents, format) {
      cents = Math.round(Number(cents) || 0);
      function fmt(precision, thousands, decimal) {
        var parts = (cents / 100).toFixed(precision).split('.');
        return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands) + (parts[1] ? decimal + parts[1] : '');
      }
      // Liquid is not rendered in this tag, so the fallback avoids a literal double brace.
      return String(format || 'Ã‚Â£{' + '{amount}' + '}').replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
        switch (key) {
          case 'amount_no_decimals': return fmt(0, ',', '.');
          case 'amount_with_comma_separator': return fmt(2, '.', ',');
          case 'amount_no_decimals_with_comma_separator': return fmt(0, '.', ',');
          case 'amount_with_apostrophe_separator': return fmt(2, "'", '.');
          default: return fmt(2, ',', '.');
        }
      }).replace(/<[^>]*>/g, '');
    }

    function request(url, body) {
      return fetch(url, {
        method: body ? 'POST' : 'GET',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: body ? JSON.stringify(body) : undefined
      }).then(function (res) {
        return res.json().then(function (json) {
          if (!res.ok) throw new Error(json.description || json.message || 'Request failed');
          return json;
        });
      });
    }

    /* ---------- Countdown (offer bar + drawer) ---------- */
    function pad(n) { return n < 10 ? '0' + n : String(n); }
    function timeLeft(ms) {
      var s = Math.floor(ms / 1000);
      var d = Math.floor(s / 86400), h = Math.floor((s % 86400) / 3600), m = Math.floor((s % 3600) / 60), sec = s % 60;
      if (d > 0) return d + 'd ' + pad(h) + ':' + pad(m) + ':' + pad(sec);
      if (h > 0) return pad(h) + ':' + pad(m) + ':' + pad(sec);
      return pad(m) + ':' + pad(sec);
    }
    function startCountdown(cfg, scopes) {
      clearInterval(timers[cfg.sectionId]);
      if (!cfg.offerEnd) return;
      function tick() {
        var left = cfg.offerEnd - Date.now();
        scopes.forEach(function (scope) {
          if (!scope) return;
          qsa(scope, '[data-ezp-timer]').forEach(function (el) { el.hidden = left <= 0; });
          qsa(scope, '[data-ezp-clock]').forEach(function (el) { el.textContent = left > 0 ? timeLeft(left) : '00:00'; });
        });
        if (left <= 0) clearInterval(timers[cfg.sectionId]);
      }
      tick();
      timers[cfg.sectionId] = setInterval(tick, 1000);
    }

    /* Cart timer: starts when the cart first gets an item and keeps its start time across
       page loads, so it never restarts on refresh. It is cleared when the cart is emptied,
       and a new cart (e.g. after an order) gets a fresh one.
       At zero it says the cart is still saved rather than pretending anything expired. */
    function cartTimer(el, cfg) {
      var box = qs(el, '[data-ezp-ctimer]');
      if (!box || !(cfg.cartTimer > 0)) return null;
      var KEY = 'ezp-cart-timer';
      var run = qs(box, '[data-ezp-ctimer-run]'), done = qs(box, '[data-ezp-ctimer-done]'), clock = qs(box, '[data-ezp-ctimer-clock]');
      var start = 0, tick = null, cartToken = '';
      function load() {
        try {
          var saved = (localStorage.getItem(KEY) || '').split('|');
          return saved[0] === cartToken ? Number(saved[1]) || 0 : 0;
        } catch (e) { return 0; }
      }
      function save(v) { try { if (v) localStorage.setItem(KEY, cartToken + '|' + v); else localStorage.removeItem(KEY); } catch (e) {} }
      function paint() {
        var left = start + cfg.cartTimer * 60000 - Date.now();
        var over = left <= 0;
        run.hidden = over;
        done.hidden = !over;
        box.classList.toggle('is-done', over);
        if (over) { clearInterval(tick); return; }
        clock.textContent = timeLeft(left);
      }
      return {
        sync: function (count, token) {
          clearInterval(tick);
          if (!count) { start = 0; save(0); box.hidden = true; return; }
          if (token && token !== cartToken) { cartToken = token; start = 0; }
          start = load() || start || Date.now();
          save(start);
          box.hidden = false;
          paint();
          if (!box.classList.contains('is-done')) tick = setInterval(paint, 1000);
        }
      };
    }

    /* ---------- Gallery ---------- */
    function initGallery(root) {
      var gallery = qs(root, '[data-ezp-gallery]');
      if (!gallery) return;
      var track = qs(gallery, '[data-ezp-track]');
      var slides = qsa(track, '.ezp-gallery__slide');
      var thumbsBox = qs(gallery, '[data-ezp-thumbs]');
      var thumbs = qsa(gallery, '[data-ezp-thumb]');
      var counter = qs(gallery, '[data-ezp-current]');
      var index = 0, frame = null;
      if (slides.length < 2) return;

      function mark(i) {
        index = i;
        if (counter) counter.textContent = i + 1;
        thumbs.forEach(function (t, n) {
          var on = n === i;
          t.classList.toggle('is-active', on);
          if (on) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
        });
        var active = thumbs[i];
        if (thumbsBox && active) {
          thumbsBox.scrollTo({ left: active.offsetLeft - (thumbsBox.clientWidth - active.clientWidth) / 2, behavior: 'smooth' });
        }
      }
      function go(i) {
        i = (i + slides.length) % slides.length;
        track.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' });
        mark(i);
      }

      track.addEventListener('scroll', function () {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(function () {
          var i = Math.round(track.scrollLeft / track.clientWidth);
          if (i !== index && slides[i]) mark(i);
        });
      }, { passive: true });
      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); go(index + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); go(index - 1); }
      });
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () { go(Number(t.getAttribute('data-ezp-thumb'))); });
      });
      var prev = qs(gallery, '[data-ezp-prev]'), next = qs(gallery, '[data-ezp-next]');
      if (prev) prev.addEventListener('click', function () { go(index - 1); });
      if (next) next.addEventListener('click', function () { go(index + 1); });
    }

    /* ---------- Cart drawer ---------- */
    function createDrawer(root, cfg) {
      var el = qs(root, '[data-ezp-drawer]');
      if (!el) return null;

      // Live outside the section so no theme wrapper can clip a fixed element.
      qsa(document.body, ':scope > [data-ezp-drawer="' + cfg.sectionId + '"]').forEach(function (old) { old.remove(); });
      document.body.appendChild(el);

      var panel = qs(el, '.ezp-drawer__panel');
      var lines = qs(el, '[data-ezp-lines]');
      var track = qs(el, '[data-ezp-tracker]');
      var upsell = qs(el, '[data-ezp-upsell]');
      var noteBox = qs(el, '[data-ezp-note-box]');
      var note = qs(el, '[data-ezp-note]');
      var promo = qs(el, '[data-ezp-promo]');
      var promoInput = promo && promo.querySelector('input');
      var promoMsg = qs(el, '[data-ezp-promo-msg]');
      var codesEl = qs(el, '[data-ezp-codes]');
      var foot = qs(el, '[data-ezp-foot]');
      var savings = qs(el, '[data-ezp-savings]');
      var savingsAmt = qs(el, '[data-ezp-savings-amt]');
      var subtotal = qs(el, '[data-ezp-subtotal]');
      var checkoutTotal = qs(el, '[data-ezp-checkout-total]');
      var errorEl = qs(el, '[data-ezp-msg]');
      var timer = cartTimer(el, cfg);
      var tiers = (cfg.tiers || []).slice().sort(function (a, b) { return a.qty - b.qty; });
      var lastFocus = null;
      var codes = [];
      var upsellVariant = null;

      function isOpen() { return el.classList.contains('is-open'); }
      function open(trigger) {
        lastFocus = trigger || document.activeElement;
        if (!isOpen()) qs(el, '.ezp-drawer__body').scrollTop = 0;
        el.classList.add('is-open');
        el.setAttribute('aria-hidden', 'false');
        document.documentElement.classList.add('ezp-lock');
        setTimeout(function () { panel.focus({ preventScroll: true }); }, 60);
      }
      function close() {
        el.classList.remove('is-open');
        el.setAttribute('aria-hidden', 'true');
        document.documentElement.classList.remove('ezp-lock');
        if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus({ preventScroll: true });
      }
      function busy(on) { el.classList.toggle('is-busy', on); }
      function say(text, kind) {
        if (!promoMsg) {
          errorEl.textContent = kind === 'err' ? text || '' : '';
          errorEl.hidden = !errorEl.textContent;
          return;
        }
        promoMsg.textContent = text || '';
        promoMsg.className = 'ezp-promo__msg' + (kind ? ' is-' + kind : '');
      }

      function syncThemeCount(count) {
        qsa(document, 'cart-icon').forEach(function (icon) {
          if (typeof icon.renderCartBubble === 'function') icon.renderCartBubble(count, false);
        });
        qsa(document, '[data-cart-count]').forEach(function (n) {
          n.textContent = count;
          n.classList.toggle('show', count > 0);
        });
      }

      function lineHtml(item) {
        var img = item.image ? item.image + (item.image.indexOf('?') > -1 ? '&' : '?') + 'width=160' : '';
        var variant = item.variant_title && !/^default title$/i.test(item.variant_title)
          ? '<p class="ezp-line__variant">' + esc(item.variant_title) + '</p>' : '';
        var allocations = item.line_level_discount_allocations || [];
        var discounts = allocations.map(function (a) {
          var name = (a.discount_application && a.discount_application.title) || 'Discount';
          return '<p class="ezp-line__disc">' + esc(name) + ' (&minus;' + esc(money(a.amount, cfg.moneyFormat)) + ')</p>';
        }).join('');
        var was = item.original_line_price > item.final_line_price
          ? '<s>' + esc(money(item.original_line_price, cfg.moneyFormat)) + '</s>' : '';
        var key = esc(item.key);
        // This product shows the same title as the page; anything else keeps its own.
        var name = item.product_id === cfg.productId && cfg.title ? cfg.title : item.product_title;
        return '<div class="ezp-line">' +
          (img ? '<img class="ezp-line__img" src="' + esc(img) + '" alt="" width="72" height="72" loading="lazy">' : '<span class="ezp-line__img"></span>') +
          '<div>' +
            '<a class="ezp-line__title" href="' + esc(item.url) + '">' + esc(name) + '</a>' + variant + discounts +
            '<div class="ezp-qty" role="group" aria-label="Quantity">' +
              '<button type="button" data-ezp-qty="' + (item.quantity - 1) + '" data-key="' + key + '" aria-label="Decrease quantity">&minus;</button>' +
              '<span>' + item.quantity + '</span>' +
              '<button type="button" data-ezp-qty="' + (item.quantity + 1) + '" data-key="' + key + '" aria-label="Increase quantity">+</button>' +
            '</div>' +
          '</div>' +
          '<div class="ezp-line__side">' +
            '<button type="button" class="ezp-line__remove" data-ezp-qty="0" data-key="' + key + '" aria-label="' + esc(cfg.text.remove + ' ' + name) + '">' +
              '<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 7h16M10 11v6M14 11v6M6 7l1 13h10l1-13M9 7V4h6v3"/></svg>' +
            '</button>' +
            '<p class="ezp-line__price">' + was + esc(money(item.final_line_price, cfg.moneyFormat)) + '</p>' +
          '</div>' +
        '</div>';
      }

      /* Pack tracker: milestones are counted in boxes of this product. */
      var ICONS = {
        truck: '<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M2 6h11v10H2zM13 9h4l4 4v3h-8z"/><circle cx="6" cy="18" r="2"/><circle cx="17" cy="18" r="2"/></svg>',
        box: '<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M21 8 12 3 3 8v8l9 5 9-5V8z"/><path d="m3 8 9 5 9-5M12 13v8"/></svg>'
      };
      function renderTrack(boxes, cart) {
        if (!track) return;
        track.hidden = !boxes || tiers.length < 2;
        if (track.hidden) return;
        var max = tiers[tiers.length - 1].qty;
        var shipOk = !(Number(cfg.freeShip) > 0) || cart.total_price >= cfg.freeShip;
        var next = tiers.filter(function (t) { return t.qty > boxes; })[0];
        var msg;
        if (!shipOk) {
          msg = esc(cfg.shipTodo).replace('[amount]', '<strong>' + esc(money(cfg.freeShip - cart.total_price, cfg.moneyFormat)) + '</strong>');
        } else if (next) {
          var more = next.qty - boxes;
          msg = esc(cfg.text.trackTodo)
            .replace('[count]', '<strong>' + more + '</strong>')
            .replace('[boxes]', more === 1 ? 'box' : 'boxes')
            .replace('[pack]', '<strong>' + esc(next.label) + '</strong>');
        } else {
          msg = esc(cfg.text.trackDone).replace('[pack]', '<strong>' + esc(tiers[tiers.length - 1].label) + '</strong>');
        }
        qs(track, '[data-ezp-track-msg]').innerHTML = msg;
        var pct = Math.min(100, Math.round((boxes / max) * 100));
        qs(track, '[data-ezp-track-fill]').style.width = pct + '%';
        qs(track, '[data-ezp-track-line]').setAttribute('aria-valuenow', pct);
        qs(track, '[data-ezp-track-steps]').innerHTML = tiers.map(function (t, i) {
          var done = i === 0 ? boxes >= t.qty && shipOk : boxes >= t.qty;
          return '<li class="ezp-track__step' + (done ? ' is-done' : '') + '" style="left:' + (t.qty / max) * 100 + '%">' +
            '<span class="ezp-track__dot">' + (ICONS[t.icon] || ICONS.box) + '</span>' +
            '<span class="ezp-track__label">' + esc(t.label) + '</span></li>';
        }).join('');
      }

      /* "One more box" card, until the biggest pack is reached. */
      function renderUpsell(boxes, line) {
        if (!upsell) return;
        var next = tiers.filter(function (t) { return t.qty > boxes; })[0];
        upsellVariant = line ? line.variant_id : null;
        upsell.hidden = !line || !next || !boxes;
        if (upsell.hidden) return;
        var more = next.qty - boxes;
        qs(upsell, '[data-ezp-upsell-title]').textContent = cfg.text.upsellTitle.replace('[pack]', next.label);
        qs(upsell, '[data-ezp-upsell-text]').textContent = 'Add ' + more + ' more ' + (more === 1 ? 'box' : 'boxes');
        qs(upsell, '[data-ezp-upsell-price]').textContent = '+' + money(line.price * more, cfg.moneyFormat);
        upsell.setAttribute('data-more', more);
      }

      function render(cart) {
        var count = cart.item_count || 0;
        qsa(el, '[data-ezp-count]').forEach(function (n) { n.textContent = count; });
        syncThemeCount(count);
        if (timer) timer.sync(count, cart.token);

        var ours = (cart.items || []).filter(function (i) { return i.product_id === cfg.productId; });
        var boxes = ours.reduce(function (sum, i) { return sum + i.quantity; }, 0);
        renderTrack(boxes, cart);
        renderUpsell(boxes, ours[0]);
        if (promo) promo.hidden = !count;
        if (noteBox) noteBox.hidden = !count;
        if (note && document.activeElement !== note) note.value = cart.note || '';
        foot.hidden = !count;

        if (!count) {
          lines.innerHTML = '<div class="ezp-empty"><p>' + esc(cfg.text.empty) + '</p>' +
            '<button type="button" data-ezp-close>' + esc(cfg.text.continue) + '</button></div>';
          if (codesEl) codesEl.innerHTML = '';
          return cart;
        }

        lines.innerHTML = cart.items.map(lineHtml).join('');
        codes = (cart.discount_codes || []).filter(function (d) { return d.applicable; }).map(function (d) { return d.code; });
        if (codesEl) {
          codesEl.innerHTML = codes.map(function (c) {
            return '<li>' + esc(c) + '<button type="button" data-ezp-uncode="' + esc(c) + '" aria-label="Remove code ' + esc(c) + '">&times;</button></li>';
          }).join('');
        }
        savings.hidden = !(cart.total_discount > 0);
        savingsAmt.textContent = money(cart.total_discount, cfg.moneyFormat);
        subtotal.textContent = money(cart.total_price, cfg.moneyFormat);
        if (checkoutTotal) checkoutTotal.textContent = money(cart.total_price, cfg.moneyFormat);
        return cart;
      }

      function refresh() { return request(cfg.routes.cart + '.js').then(render); }

      function changeLine(key, qty) {
        busy(true);
        say('');
        return request(cfg.routes.change + '.js', { id: key, quantity: Math.max(0, qty) })
          .then(render)
          .catch(function (err) { say(err.message, 'err'); return refresh(); })
          .then(function () { busy(false); });
      }

      if (upsell) {
        qs(upsell, '[data-ezp-upsell-add]').addEventListener('click', function () {
          if (!upsellVariant) return;
          busy(true);
          say('');
          request(cfg.routes.add + '.js', { items: [{ id: upsellVariant, quantity: Number(upsell.getAttribute('data-more')) || 1 }] })
            .then(refresh)
            .catch(function (err) { say(err.message || cfg.text.error, 'err'); })
            .then(function () { busy(false); });
        });
      }

      // Order note: saved to the cart shortly after typing stops, so it reaches checkout.
      if (note) {
        var noteTimer = null, noteSaving = null;
        var saveNote = function () {
          clearTimeout(noteTimer);
          noteTimer = null;
          noteSaving = request(cfg.routes.update + '.js', { note: note.value }).catch(function () {});
          return noteSaving;
        };
        note.addEventListener('input', function () { clearTimeout(noteTimer); noteTimer = setTimeout(saveNote, 600); });
        note.addEventListener('blur', function () { if (noteTimer) saveNote(); });
        // A note typed right before tapping checkout is saved first.
        qs(el, '[data-ezp-checkout]').addEventListener('click', function (e) {
          if (!noteTimer && !noteSaving) return;
          e.preventDefault();
          var href = this.href;
          (noteTimer ? saveNote() : noteSaving).then(function () { window.location.href = href; });
        });
      }

      function setCodes(list) { return request(cfg.routes.update + '.js', { discount: list.join(',') }); }

      if (promo) promo.addEventListener('submit', function (e) {
        e.preventDefault();
        var code = promoInput.value.trim();
        if (!code) return;
        if (codes.some(function (c) { return c.toLowerCase() === code.toLowerCase(); })) {
          say(cfg.text.codeOk.replace('[code]', code.toUpperCase()), 'ok');
          return;
        }
        busy(true);
        say('');
        setCodes(codes.concat(code))
          .then(function (cart) {
            var hit = (cart.discount_codes || []).filter(function (d) { return d.code.toLowerCase() === code.toLowerCase(); })[0];
            if (hit && hit.applicable) {
              promoInput.value = '';
              say(cfg.text.codeOk.replace('[code]', hit.code.toUpperCase()), 'ok');
              return render(cart);
            }
            say(cfg.text.codeBad, 'err');
            // Drop the rejected code so it does not linger on the cart.
            var keep = (cart.discount_codes || []).filter(function (d) { return d.applicable; }).map(function (d) { return d.code; });
            return setCodes(keep).then(render);
          })
          .catch(function () { say(cfg.text.codeBad, 'err'); })
          .then(function () { busy(false); });
      });

      el.addEventListener('click', function (e) {
        var t = e.target;
        if (t.closest('[data-ezp-close]')) { e.preventDefault(); close(); return; }
        var qtyBtn = t.closest('[data-ezp-qty]');
        if (qtyBtn) { changeLine(qtyBtn.getAttribute('data-key'), Number(qtyBtn.getAttribute('data-ezp-qty'))); return; }
        var uncode = t.closest('[data-ezp-uncode]');
        if (uncode) {
          var drop = uncode.getAttribute('data-ezp-uncode');
          busy(true);
          setCodes(codes.filter(function (c) { return c !== drop; }))
            .then(render)
            .then(function () { say(''); busy(false); }, function () { busy(false); });
        }
      });

      el.addEventListener('keydown', function (e) {
        if (!isOpen()) return;
        if (e.key === 'Escape') { e.stopPropagation(); close(); return; }
        if (e.key !== 'Tab') return;
        var focusable = qsa(panel, 'a[href], button:not([disabled]), input:not([disabled]), select, textarea, summary').filter(function (x) { return x.offsetParent !== null; });
        if (!focusable.length) return;
        var first = focusable[0], last = focusable[focusable.length - 1];
        if (e.shiftKey && (document.activeElement === first || document.activeElement === panel)) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      });

      return {
        el: el,
        open: open,
        close: close,
        refresh: refresh,
        alive: function () { return document.body.contains(el); }
      };
    }

    /* Header cart icon opens this drawer instead of the theme's own one. */
    function takeOverThemeCart(drawer) {
      var first = !window.__ezpCart;
      window.__ezpCart = drawer;
      if (!first) return;
      window.addEventListener('click', function (e) {
        var d = window.__ezpCart;
        if (!d || !d.alive() || !e.target.closest) return;
        var trigger = e.target.closest('[aria-controls="cart-drawer"], a.action__cart, #cartOpen, #headerCartPageLink, [data-ezp-open-cart]');
        if (!trigger) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        d.open(trigger);
        d.refresh().catch(function () {});
      }, true);
    }

    /* ---------- Sticky add-to-cart bar (shows once the main button scrolls away) ---------- */
    function initSticky(root, cfg, form, button) {
      var bar = qs(root, '[data-ezp-sticky]');
      if (!bar || !button) return null;
      qsa(document.body, ':scope > [data-ezp-sticky="' + cfg.sectionId + '"]').forEach(function (old) { old.remove(); });
      document.body.appendChild(bar);
      document.body.classList.add('ezp-has-sticky');
      var btn = qs(bar, '[data-ezp-sticky-btn]');
      btn.addEventListener('click', function () {
        if (typeof form.requestSubmit === 'function') form.requestSubmit(button);
        else button.click();
      });
      function show(on) {
        bar.classList.toggle('is-visible', on);
        bar.setAttribute('aria-hidden', on ? 'false' : 'true');
        btn.tabIndex = on ? 0 : -1;
      }
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          var e = entries[0];
          show(!e.isIntersecting && e.boundingClientRect.top < 0);
        }).observe(button);
      }
      return {
        update: function (title, price) {
          qs(bar, '[data-ezp-sticky-title]').textContent = title;
          qs(bar, '[data-ezp-sticky-price]').textContent = price;
        },
        busy: function (on) { btn.disabled = on; }
      };
    }

    /* ---------- Buy box: bundles, variant, add to cart ---------- */
    function initBuyBox(root, cfg, drawer) {
      var form = qs(root, '[data-ezp-form]');
      if (!form) return;
      var radios = qsa(form, '[data-ezp-bundle]');
      var idInput = qs(form, '[data-ezp-variant-id]');
      var select = qs(form, '[data-ezp-variant-select]');
      var button = qs(form, '[data-ezp-add]');
      var errorEl = qs(form, '[data-ezp-error]');
      var priceBox = qs(root, '[data-ezp-price-box]');
      var sticky = initSticky(root, cfg, form, button);

      // Main price follows the tapped pack: total, struck-through regular price, saving and per-box note.
      function updatePrice(animate) {
        if (!priceBox) return;
        var unit = Number(priceBox.getAttribute('data-unit')) || 0;
        var unitCompare = Number(priceBox.getAttribute('data-unit-compare')) || 0;
        var picked = qs(form, '[data-ezp-bundle]:checked');
        var qty = picked ? Number(picked.getAttribute('data-qty')) || 1 : 1;
        var fixed = picked ? Number(picked.getAttribute('data-fixed')) || 0 : 0;
        var full = unit * qty, total = fixed > 0 ? fixed : full;
        var was = full > total ? full : (qty === 1 && unitCompare > unit ? unitCompare : 0);
        var compareEl = qs(priceBox, '[data-ezp-compare]'), saveEl = qs(priceBox, '[data-ezp-save]'), noteEl = qs(priceBox, '[data-ezp-price-note]');

        qs(priceBox, '[data-ezp-price]').textContent = money(total, cfg.moneyFormat);
        compareEl.hidden = saveEl.hidden = !was;
        if (was) {
          compareEl.textContent = money(was, cfg.moneyFormat);
          saveEl.textContent = 'Save ' + Math.round(((was - total) / was) * 100) + '%';
        }
        if (noteEl) {
          var template = noteEl.getAttribute('data-template') || '';
          noteEl.classList.toggle('is-off', qty < 2);
          if (qty > 1) noteEl.textContent = template.replace('[qty]', qty).replace('[each]', money(Math.floor(total / qty), cfg.moneyFormat));
        }
        if (sticky) {
          var titleEl = picked ? qs(picked.closest('.ezp-bundle'), '.ezp-bundle__title') : null;
          sticky.update(titleEl ? titleEl.textContent : '', money(total, cfg.moneyFormat));
        }
        if (animate) {
          priceBox.classList.remove('is-bump');
          void priceBox.offsetWidth;
          priceBox.classList.add('is-bump');
        }
      }

      function syncCards() {
        radios.forEach(function (r) { r.closest('.ezp-bundle').classList.toggle('is-selected', r.checked); });
      }
      radios.forEach(function (r) {
        r.addEventListener('change', function () { syncCards(); updatePrice(true); });
      });
      syncCards();
      updatePrice(false);

      if (select) {
        select.addEventListener('change', function () {
          var opt = select.options[select.selectedIndex];
          var price = Number(opt.getAttribute('data-price'));
          idInput.value = select.value;
          if (priceBox) {
            priceBox.setAttribute('data-unit', price);
            priceBox.setAttribute('data-unit-compare', Number(opt.getAttribute('data-compare')) || 0);
          }
          updatePrice(true);
          radios.forEach(function (r) {
            var card = r.closest('.ezp-bundle');
            var qty = Number(r.getAttribute('data-qty')) || 1;
            var fixed = Number(r.getAttribute('data-fixed')) || 0;
            var full = price * qty, total = fixed > 0 ? fixed : full;
            qs(card, '[data-ezp-total]').textContent = money(total, cfg.moneyFormat);
            qs(card, '[data-ezp-each]').textContent = money(Math.floor(total / qty), cfg.moneyFormat) + '/ea';
            var fullEl = qs(card, '[data-ezp-full]');
            fullEl.textContent = money(full, cfg.moneyFormat);
            fullEl.hidden = !(full > total);
          });
        });
      }

      form.addEventListener('submit', function (e) {
        if (!drawer) return; // No drawer: let the form post to /cart/add as normal.
        e.preventDefault();
        var picked = qs(form, '[data-ezp-bundle]:checked');
        var qty = picked ? Number(picked.value) : 1;
        button.disabled = true;
        button.classList.add('is-loading');
        if (sticky) sticky.busy(true);
        errorEl.hidden = true;
        request(cfg.routes.add + '.js', { items: [{ id: Number(idInput.value), quantity: qty }] })
          .then(function () { return drawer.refresh(); })
          .then(function () { drawer.open(button); })
          .catch(function (err) {
            errorEl.textContent = err.message || cfg.text.error;
            errorEl.hidden = false;
          })
          .then(function () {
            button.disabled = false;
            button.classList.remove('is-loading');
            if (sticky) sticky.busy(false);
          });
      });
    }

    function init(root) {
      if (root.__ezpReady) return;
      root.__ezpReady = true;
      var cfgEl = qs(root, '[data-ezp-config]');
      if (!cfgEl) return;
      var cfg = JSON.parse(cfgEl.textContent);
      var drawer = cfg.drawer ? createDrawer(root, cfg) : null;
      initGallery(root);
      initBuyBox(root, cfg, drawer);
      startCountdown(cfg, [root, drawer && drawer.el]);
      if (drawer && cfg.takeover) takeOverThemeCart(drawer);
    }

    function boot(scope) { qsa(scope || document, '[data-ezp-root]').forEach(init); }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
    else boot();

    document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
    document.addEventListener('shopify:section:unload', function (e) {
      var root = qs(e.target, '[data-ezp-root]');
      if (!root) return;
      var id = root.getAttribute('data-section-id');
      clearInterval(timers[id]);
      qsa(document.body, ':scope > [data-ezp-drawer="' + id + '"], :scope > [data-ezp-sticky="' + id + '"]').forEach(function (d) { d.remove(); });
      document.documentElement.classList.remove('ezp-lock');
      document.body.classList.remove('ezp-has-sticky');
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ezonzy-honey-landing"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    var timers = {};

    function qs(el, s) { return el.querySelector(s); }
    function qsa(el, s) { return Array.prototype.slice.call(el.querySelectorAll(s)); }
    function esc(str) {
      return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    function money(cents, format) {
      cents = Math.round(Number(cents) || 0);
      function fmt(precision, thousands, decimal) {
        var parts = (cents / 100).toFixed(precision).split('.');
        return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands) + (parts[1] ? decimal + parts[1] : '');
      }
      // Liquid is not rendered in this tag, so the fallback avoids a literal double brace.
      return String(format || 'Ã‚Â£{' + '{amount}' + '}').replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
        switch (key) {
          case 'amount_no_decimals': return fmt(0, ',', '.');
          case 'amount_with_comma_separator': return fmt(2, '.', ',');
          case 'amount_no_decimals_with_comma_separator': return fmt(0, '.', ',');
          case 'amount_with_apostrophe_separator': return fmt(2, "'", '.');
          default: return fmt(2, ',', '.');
        }
      }).replace(/<[^>]*>/g, '');
    }

    function request(url, body) {
      return fetch(url, {
        method: body ? 'POST' : 'GET',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: body ? JSON.stringify(body) : undefined
      }).then(function (res) {
        return res.json().then(function (json) {
          if (!res.ok) throw new Error(json.description || json.message || 'Request failed');
          return json;
        });
      });
    }

    /* ---------- Countdown (offer bar + drawer) ---------- */
    function pad(n) { return n < 10 ? '0' + n : String(n); }
    function timeLeft(ms) {
      var s = Math.floor(ms / 1000);
      var d = Math.floor(s / 86400), h = Math.floor((s % 86400) / 3600), m = Math.floor((s % 3600) / 60), sec = s % 60;
      if (d > 0) return d + 'd ' + pad(h) + ':' + pad(m) + ':' + pad(sec);
      if (h > 0) return pad(h) + ':' + pad(m) + ':' + pad(sec);
      return pad(m) + ':' + pad(sec);
    }
    function startCountdown(cfg, scopes) {
      clearInterval(timers[cfg.sectionId]);
      if (!cfg.offerEnd) return;
      function tick() {
        var left = cfg.offerEnd - Date.now();
        scopes.forEach(function (scope) {
          if (!scope) return;
          qsa(scope, '[data-ezp-timer]').forEach(function (el) { el.hidden = left <= 0; });
          qsa(scope, '[data-ezp-clock]').forEach(function (el) { el.textContent = left > 0 ? timeLeft(left) : '00:00'; });
        });
        if (left <= 0) clearInterval(timers[cfg.sectionId]);
      }
      tick();
      timers[cfg.sectionId] = setInterval(tick, 1000);
    }

    /* Cart timer: starts when the cart first gets an item and keeps its start time across
       page loads, so it never restarts on refresh. It is cleared when the cart is emptied,
       and a new cart (e.g. after an order) gets a fresh one.
       At zero it says the cart is still saved rather than pretending anything expired. */
    function cartTimer(el, cfg) {
      var box = qs(el, '[data-ezp-ctimer]');
      if (!box || !(cfg.cartTimer > 0)) return null;
      var KEY = 'ezp-cart-timer';
      var run = qs(box, '[data-ezp-ctimer-run]'), done = qs(box, '[data-ezp-ctimer-done]'), clock = qs(box, '[data-ezp-ctimer-clock]');
      var start = 0, tick = null, cartToken = '';
      function load() {
        try {
          var saved = (localStorage.getItem(KEY) || '').split('|');
          return saved[0] === cartToken ? Number(saved[1]) || 0 : 0;
        } catch (e) { return 0; }
      }
      function save(v) { try { if (v) localStorage.setItem(KEY, cartToken + '|' + v); else localStorage.removeItem(KEY); } catch (e) {} }
      function paint() {
        var left = start + cfg.cartTimer * 60000 - Date.now();
        var over = left <= 0;
        run.hidden = over;
        done.hidden = !over;
        box.classList.toggle('is-done', over);
        if (over) { clearInterval(tick); return; }
        clock.textContent = timeLeft(left);
      }
      return {
        sync: function (count, token) {
          clearInterval(tick);
          if (!count) { start = 0; save(0); box.hidden = true; return; }
          if (token && token !== cartToken) { cartToken = token; start = 0; }
          start = load() || start || Date.now();
          save(start);
          box.hidden = false;
          paint();
          if (!box.classList.contains('is-done')) tick = setInterval(paint, 1000);
        }
      };
    }

    /* ---------- Gallery ---------- */
    function initGallery(root) {
      var gallery = qs(root, '[data-ezp-gallery]');
      if (!gallery) return;
      var track = qs(gallery, '[data-ezp-track]');
      var slides = qsa(track, '.ezp-gallery__slide');
      var thumbsBox = qs(gallery, '[data-ezp-thumbs]');
      var thumbs = qsa(gallery, '[data-ezp-thumb]');
      var counter = qs(gallery, '[data-ezp-current]');
      var index = 0, frame = null;
      if (slides.length < 2) return;

      function mark(i) {
        index = i;
        if (counter) counter.textContent = i + 1;
        thumbs.forEach(function (t, n) {
          var on = n === i;
          t.classList.toggle('is-active', on);
          if (on) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
        });
        var active = thumbs[i];
        if (thumbsBox && active) {
          thumbsBox.scrollTo({ left: active.offsetLeft - (thumbsBox.clientWidth - active.clientWidth) / 2, behavior: 'smooth' });
        }
      }
      function go(i) {
        i = (i + slides.length) % slides.length;
        track.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' });
        mark(i);
      }

      track.addEventListener('scroll', function () {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(function () {
          var i = Math.round(track.scrollLeft / track.clientWidth);
          if (i !== index && slides[i]) mark(i);
        });
      }, { passive: true });
      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); go(index + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); go(index - 1); }
      });
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () { go(Number(t.getAttribute('data-ezp-thumb'))); });
      });
      var prev = qs(gallery, '[data-ezp-prev]'), next = qs(gallery, '[data-ezp-next]');
      if (prev) prev.addEventListener('click', function () { go(index - 1); });
      if (next) next.addEventListener('click', function () { go(index + 1); });
    }

    /* ---------- Cart drawer ---------- */
    function createDrawer(root, cfg) {
      var el = qs(root, '[data-ezp-drawer]');
      if (!el) return null;

      // Live outside the section so no theme wrapper can clip a fixed element.
      qsa(document.body, ':scope > [data-ezp-drawer="' + cfg.sectionId + '"]').forEach(function (old) { old.remove(); });
      document.body.appendChild(el);

      var panel = qs(el, '.ezp-drawer__panel');
      var lines = qs(el, '[data-ezp-lines]');
      var track = qs(el, '[data-ezp-tracker]');
      var upsell = qs(el, '[data-ezp-upsell]');
      var noteBox = qs(el, '[data-ezp-note-box]');
      var note = qs(el, '[data-ezp-note]');
      var promo = qs(el, '[data-ezp-promo]');
      var promoInput = promo && promo.querySelector('input');
      var promoMsg = qs(el, '[data-ezp-promo-msg]');
      var codesEl = qs(el, '[data-ezp-codes]');
      var foot = qs(el, '[data-ezp-foot]');
      var savings = qs(el, '[data-ezp-savings]');
      var savingsAmt = qs(el, '[data-ezp-savings-amt]');
      var subtotal = qs(el, '[data-ezp-subtotal]');
      var checkoutTotal = qs(el, '[data-ezp-checkout-total]');
      var errorEl = qs(el, '[data-ezp-msg]');
      var timer = cartTimer(el, cfg);
      var tiers = (cfg.tiers || []).slice().sort(function (a, b) { return a.qty - b.qty; });
      var lastFocus = null;
      var codes = [];
      var upsellVariant = null;

      function isOpen() { return el.classList.contains('is-open'); }
      function open(trigger) {
        lastFocus = trigger || document.activeElement;
        if (!isOpen()) qs(el, '.ezp-drawer__body').scrollTop = 0;
        el.classList.add('is-open');
        el.setAttribute('aria-hidden', 'false');
        document.documentElement.classList.add('ezp-lock');
        setTimeout(function () { panel.focus({ preventScroll: true }); }, 60);
      }
      function close() {
        el.classList.remove('is-open');
        el.setAttribute('aria-hidden', 'true');
        document.documentElement.classList.remove('ezp-lock');
        if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus({ preventScroll: true });
      }
      function busy(on) { el.classList.toggle('is-busy', on); }
      function say(text, kind) {
        if (!promoMsg) {
          errorEl.textContent = kind === 'err' ? text || '' : '';
          errorEl.hidden = !errorEl.textContent;
          return;
        }
        promoMsg.textContent = text || '';
        promoMsg.className = 'ezp-promo__msg' + (kind ? ' is-' + kind : '');
      }

      function syncThemeCount(count) {
        qsa(document, 'cart-icon').forEach(function (icon) {
          if (typeof icon.renderCartBubble === 'function') icon.renderCartBubble(count, false);
        });
        qsa(document, '[data-cart-count]').forEach(function (n) {
          n.textContent = count;
          n.classList.toggle('show', count > 0);
        });
      }

      function lineHtml(item) {
        var img = item.image ? item.image + (item.image.indexOf('?') > -1 ? '&' : '?') + 'width=160' : '';
        var variant = item.variant_title && !/^default title$/i.test(item.variant_title)
          ? '<p class="ezp-line__variant">' + esc(item.variant_title) + '</p>' : '';
        var allocations = item.line_level_discount_allocations || [];
        var discounts = allocations.map(function (a) {
          var name = (a.discount_application && a.discount_application.title) || 'Discount';
          return '<p class="ezp-line__disc">' + esc(name) + ' (&minus;' + esc(money(a.amount, cfg.moneyFormat)) + ')</p>';
        }).join('');
        var was = item.original_line_price > item.final_line_price
          ? '<s>' + esc(money(item.original_line_price, cfg.moneyFormat)) + '</s>' : '';
        var key = esc(item.key);
        // This product shows the same title as the page; anything else keeps its own.
        var name = item.product_id === cfg.productId && cfg.title ? cfg.title : item.product_title;
        return '<div class="ezp-line">' +
          (img ? '<img class="ezp-line__img" src="' + esc(img) + '" alt="" width="72" height="72" loading="lazy">' : '<span class="ezp-line__img"></span>') +
          '<div>' +
            '<a class="ezp-line__title" href="' + esc(item.url) + '">' + esc(name) + '</a>' + variant + discounts +
            '<div class="ezp-qty" role="group" aria-label="Quantity">' +
              '<button type="button" data-ezp-qty="' + (item.quantity - 1) + '" data-key="' + key + '" aria-label="Decrease quantity">&minus;</button>' +
              '<span>' + item.quantity + '</span>' +
              '<button type="button" data-ezp-qty="' + (item.quantity + 1) + '" data-key="' + key + '" aria-label="Increase quantity">+</button>' +
            '</div>' +
          '</div>' +
          '<div class="ezp-line__side">' +
            '<button type="button" class="ezp-line__remove" data-ezp-qty="0" data-key="' + key + '" aria-label="' + esc(cfg.text.remove + ' ' + name) + '">' +
              '<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 7h16M10 11v6M14 11v6M6 7l1 13h10l1-13M9 7V4h6v3"/></svg>' +
            '</button>' +
            '<p class="ezp-line__price">' + was + esc(money(item.final_line_price, cfg.moneyFormat)) + '</p>' +
          '</div>' +
        '</div>';
      }

      /* Pack tracker: milestones are counted in boxes of this product. */
      var ICONS = {
        truck: '<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M2 6h11v10H2zM13 9h4l4 4v3h-8z"/><circle cx="6" cy="18" r="2"/><circle cx="17" cy="18" r="2"/></svg>',
        box: '<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M21 8 12 3 3 8v8l9 5 9-5V8z"/><path d="m3 8 9 5 9-5M12 13v8"/></svg>'
      };
      function renderTrack(boxes, cart) {
        if (!track) return;
        track.hidden = !boxes || tiers.length < 2;
        if (track.hidden) return;
        var max = tiers[tiers.length - 1].qty;
        var shipOk = !(Number(cfg.freeShip) > 0) || cart.total_price >= cfg.freeShip;
        var next = tiers.filter(function (t) { return t.qty > boxes; })[0];
        var msg;
        if (!shipOk) {
          msg = esc(cfg.shipTodo).replace('[amount]', '<strong>' + esc(money(cfg.freeShip - cart.total_price, cfg.moneyFormat)) + '</strong>');
        } else if (next) {
          var more = next.qty - boxes;
          msg = esc(cfg.text.trackTodo)
            .replace('[count]', '<strong>' + more + '</strong>')
            .replace('[boxes]', more === 1 ? 'box' : 'boxes')
            .replace('[pack]', '<strong>' + esc(next.label) + '</strong>');
        } else {
          msg = esc(cfg.text.trackDone).replace('[pack]', '<strong>' + esc(tiers[tiers.length - 1].label) + '</strong>');
        }
        qs(track, '[data-ezp-track-msg]').innerHTML = msg;
        var pct = Math.min(100, Math.round((boxes / max) * 100));
        qs(track, '[data-ezp-track-fill]').style.width = pct + '%';
        qs(track, '[data-ezp-track-line]').setAttribute('aria-valuenow', pct);
        qs(track, '[data-ezp-track-steps]').innerHTML = tiers.map(function (t, i) {
          var done = i === 0 ? boxes >= t.qty && shipOk : boxes >= t.qty;
          return '<li class="ezp-track__step' + (done ? ' is-done' : '') + '" style="left:' + (t.qty / max) * 100 + '%">' +
            '<span class="ezp-track__dot">' + (ICONS[t.icon] || ICONS.box) + '</span>' +
            '<span class="ezp-track__label">' + esc(t.label) + '</span></li>';
        }).join('');
      }

      /* "One more box" card, until the biggest pack is reached. */
      function renderUpsell(boxes, line) {
        if (!upsell) return;
        var next = tiers.filter(function (t) { return t.qty > boxes; })[0];
        upsellVariant = line ? line.variant_id : null;
        upsell.hidden = !line || !next || !boxes;
        if (upsell.hidden) return;
        var more = next.qty - boxes;
        qs(upsell, '[data-ezp-upsell-title]').textContent = cfg.text.upsellTitle.replace('[pack]', next.label);
        qs(upsell, '[data-ezp-upsell-text]').textContent = 'Add ' + more + ' more ' + (more === 1 ? 'box' : 'boxes');
        qs(upsell, '[data-ezp-upsell-price]').textContent = '+' + money(line.price * more, cfg.moneyFormat);
        upsell.setAttribute('data-more', more);
      }

      function render(cart) {
        var count = cart.item_count || 0;
        qsa(el, '[data-ezp-count]').forEach(function (n) { n.textContent = count; });
        syncThemeCount(count);
        if (timer) timer.sync(count, cart.token);

        var ours = (cart.items || []).filter(function (i) { return i.product_id === cfg.productId; });
        var boxes = ours.reduce(function (sum, i) { return sum + i.quantity; }, 0);
        renderTrack(boxes, cart);
        renderUpsell(boxes, ours[0]);
        if (promo) promo.hidden = !count;
        if (noteBox) noteBox.hidden = !count;
        if (note && document.activeElement !== note) note.value = cart.note || '';
        foot.hidden = !count;

        if (!count) {
          lines.innerHTML = '<div class="ezp-empty"><p>' + esc(cfg.text.empty) + '</p>' +
            '<button type="button" data-ezp-close>' + esc(cfg.text.continue) + '</button></div>';
          if (codesEl) codesEl.innerHTML = '';
          return cart;
        }

        lines.innerHTML = cart.items.map(lineHtml).join('');
        codes = (cart.discount_codes || []).filter(function (d) { return d.applicable; }).map(function (d) { return d.code; });
        if (codesEl) {
          codesEl.innerHTML = codes.map(function (c) {
            return '<li>' + esc(c) + '<button type="button" data-ezp-uncode="' + esc(c) + '" aria-label="Remove code ' + esc(c) + '">&times;</button></li>';
          }).join('');
        }
        savings.hidden = !(cart.total_discount > 0);
        savingsAmt.textContent = money(cart.total_discount, cfg.moneyFormat);
        subtotal.textContent = money(cart.total_price, cfg.moneyFormat);
        if (checkoutTotal) checkoutTotal.textContent = money(cart.total_price, cfg.moneyFormat);
        return cart;
      }

      function refresh() { return request(cfg.routes.cart + '.js').then(render); }

      function changeLine(key, qty) {
        busy(true);
        say('');
        return request(cfg.routes.change + '.js', { id: key, quantity: Math.max(0, qty) })
          .then(render)
          .catch(function (err) { say(err.message, 'err'); return refresh(); })
          .then(function () { busy(false); });
      }

      if (upsell) {
        qs(upsell, '[data-ezp-upsell-add]').addEventListener('click', function () {
          if (!upsellVariant) return;
          busy(true);
          say('');
          request(cfg.routes.add + '.js', { items: [{ id: upsellVariant, quantity: Number(upsell.getAttribute('data-more')) || 1 }] })
            .then(refresh)
            .catch(function (err) { say(err.message || cfg.text.error, 'err'); })
            .then(function () { busy(false); });
        });
      }

      // Order note: saved to the cart shortly after typing stops, so it reaches checkout.
      if (note) {
        var noteTimer = null, noteSaving = null;
        var saveNote = function () {
          clearTimeout(noteTimer);
          noteTimer = null;
          noteSaving = request(cfg.routes.update + '.js', { note: note.value }).catch(function () {});
          return noteSaving;
        };
        note.addEventListener('input', function () { clearTimeout(noteTimer); noteTimer = setTimeout(saveNote, 600); });
        note.addEventListener('blur', function () { if (noteTimer) saveNote(); });
        // A note typed right before tapping checkout is saved first.
        qs(el, '[data-ezp-checkout]').addEventListener('click', function (e) {
          if (!noteTimer && !noteSaving) return;
          e.preventDefault();
          var href = this.href;
          (noteTimer ? saveNote() : noteSaving).then(function () { window.location.href = href; });
        });
      }

      function setCodes(list) { return request(cfg.routes.update + '.js', { discount: list.join(',') }); }

      if (promo) promo.addEventListener('submit', function (e) {
        e.preventDefault();
        var code = promoInput.value.trim();
        if (!code) return;
        if (codes.some(function (c) { return c.toLowerCase() === code.toLowerCase(); })) {
          say(cfg.text.codeOk.replace('[code]', code.toUpperCase()), 'ok');
          return;
        }
        busy(true);
        say('');
        setCodes(codes.concat(code))
          .then(function (cart) {
            var hit = (cart.discount_codes || []).filter(function (d) { return d.code.toLowerCase() === code.toLowerCase(); })[0];
            if (hit && hit.applicable) {
              promoInput.value = '';
              say(cfg.text.codeOk.replace('[code]', hit.code.toUpperCase()), 'ok');
              return render(cart);
            }
            say(cfg.text.codeBad, 'err');
            // Drop the rejected code so it does not linger on the cart.
            var keep = (cart.discount_codes || []).filter(function (d) { return d.applicable; }).map(function (d) { return d.code; });
            return setCodes(keep).then(render);
          })
          .catch(function () { say(cfg.text.codeBad, 'err'); })
          .then(function () { busy(false); });
      });

      el.addEventListener('click', function (e) {
        var t = e.target;
        if (t.closest('[data-ezp-close]')) { e.preventDefault(); close(); return; }
        var qtyBtn = t.closest('[data-ezp-qty]');
        if (qtyBtn) { changeLine(qtyBtn.getAttribute('data-key'), Number(qtyBtn.getAttribute('data-ezp-qty'))); return; }
        var uncode = t.closest('[data-ezp-uncode]');
        if (uncode) {
          var drop = uncode.getAttribute('data-ezp-uncode');
          busy(true);
          setCodes(codes.filter(function (c) { return c !== drop; }))
            .then(render)
            .then(function () { say(''); busy(false); }, function () { busy(false); });
        }
      });

      el.addEventListener('keydown', function (e) {
        if (!isOpen()) return;
        if (e.key === 'Escape') { e.stopPropagation(); close(); return; }
        if (e.key !== 'Tab') return;
        var focusable = qsa(panel, 'a[href], button:not([disabled]), input:not([disabled]), select, textarea, summary').filter(function (x) { return x.offsetParent !== null; });
        if (!focusable.length) return;
        var first = focusable[0], last = focusable[focusable.length - 1];
        if (e.shiftKey && (document.activeElement === first || document.activeElement === panel)) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      });

      return {
        el: el,
        open: open,
        close: close,
        refresh: refresh,
        alive: function () { return document.body.contains(el); }
      };
    }

    /* Header cart icon opens this drawer instead of the theme's own one. */
    function takeOverThemeCart(drawer) {
      var first = !window.__ezpCart;
      window.__ezpCart = drawer;
      if (!first) return;
      window.addEventListener('click', function (e) {
        var d = window.__ezpCart;
        if (!d || !d.alive() || !e.target.closest) return;
        var trigger = e.target.closest('[aria-controls="cart-drawer"], a.action__cart, #cartOpen, #headerCartPageLink, [data-ezp-open-cart]');
        if (!trigger) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        d.open(trigger);
        d.refresh().catch(function () {});
      }, true);
    }

    /* ---------- Sticky add-to-cart bar (shows once the main button scrolls away) ---------- */
    function initSticky(root, cfg, form, button) {
      var bar = qs(root, '[data-ezp-sticky]');
      if (!bar || !button) return null;
      qsa(document.body, ':scope > [data-ezp-sticky="' + cfg.sectionId + '"]').forEach(function (old) { old.remove(); });
      document.body.appendChild(bar);
      document.body.classList.add('ezp-has-sticky');
      var btn = qs(bar, '[data-ezp-sticky-btn]');
      btn.addEventListener('click', function () {
        if (typeof form.requestSubmit === 'function') form.requestSubmit(button);
        else button.click();
      });
      function show(on) {
        bar.classList.toggle('is-visible', on);
        bar.setAttribute('aria-hidden', on ? 'false' : 'true');
        btn.tabIndex = on ? 0 : -1;
      }
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          var e = entries[0];
          show(!e.isIntersecting && e.boundingClientRect.top < 0);
        }).observe(button);
      }
      return {
        update: function (title, price) {
          qs(bar, '[data-ezp-sticky-title]').textContent = title;
          qs(bar, '[data-ezp-sticky-price]').textContent = price;
        },
        busy: function (on) { btn.disabled = on; }
      };
    }

    /* ---------- Buy box: bundles, variant, add to cart ---------- */
    function initBuyBox(root, cfg, drawer) {
      var form = qs(root, '[data-ezp-form]');
      if (!form) return;
      var radios = qsa(form, '[data-ezp-bundle]');
      var idInput = qs(form, '[data-ezp-variant-id]');
      var select = qs(form, '[data-ezp-variant-select]');
      var button = qs(form, '[data-ezp-add]');
      var errorEl = qs(form, '[data-ezp-error]');
      var priceBox = qs(root, '[data-ezp-price-box]');
      var sticky = initSticky(root, cfg, form, button);

      // Main price follows the tapped pack: total, struck-through regular price, saving and per-box note.
      function updatePrice(animate) {
        if (!priceBox) return;
        var unit = Number(priceBox.getAttribute('data-unit')) || 0;
        var unitCompare = Number(priceBox.getAttribute('data-unit-compare')) || 0;
        var picked = qs(form, '[data-ezp-bundle]:checked');
        var qty = picked ? Number(picked.getAttribute('data-qty')) || 1 : 1;
        var fixed = picked ? Number(picked.getAttribute('data-fixed')) || 0 : 0;
        var full = unit * qty, total = fixed > 0 ? fixed : full;
        var was = full > total ? full : (qty === 1 && unitCompare > unit ? unitCompare : 0);
        var compareEl = qs(priceBox, '[data-ezp-compare]'), saveEl = qs(priceBox, '[data-ezp-save]'), noteEl = qs(priceBox, '[data-ezp-price-note]');

        qs(priceBox, '[data-ezp-price]').textContent = money(total, cfg.moneyFormat);
        compareEl.hidden = saveEl.hidden = !was;
        if (was) {
          compareEl.textContent = money(was, cfg.moneyFormat);
          saveEl.textContent = 'Save ' + Math.round(((was - total) / was) * 100) + '%';
        }
        if (noteEl) {
          var template = noteEl.getAttribute('data-template') || '';
          noteEl.classList.toggle('is-off', qty < 2);
          if (qty > 1) noteEl.textContent = template.replace('[qty]', qty).replace('[each]', money(Math.floor(total / qty), cfg.moneyFormat));
        }
        if (sticky) {
          var titleEl = picked ? qs(picked.closest('.ezp-bundle'), '.ezp-bundle__title') : null;
          sticky.update(titleEl ? titleEl.textContent : '', money(total, cfg.moneyFormat));
        }
        if (animate) {
          priceBox.classList.remove('is-bump');
          void priceBox.offsetWidth;
          priceBox.classList.add('is-bump');
        }
      }

      function syncCards() {
        radios.forEach(function (r) { r.closest('.ezp-bundle').classList.toggle('is-selected', r.checked); });
      }
      radios.forEach(function (r) {
        r.addEventListener('change', function () { syncCards(); updatePrice(true); });
      });
      syncCards();
      updatePrice(false);

      if (select) {
        select.addEventListener('change', function () {
          var opt = select.options[select.selectedIndex];
          var price = Number(opt.getAttribute('data-price'));
          idInput.value = select.value;
          if (priceBox) {
            priceBox.setAttribute('data-unit', price);
            priceBox.setAttribute('data-unit-compare', Number(opt.getAttribute('data-compare')) || 0);
          }
          updatePrice(true);
          radios.forEach(function (r) {
            var card = r.closest('.ezp-bundle');
            var qty = Number(r.getAttribute('data-qty')) || 1;
            var fixed = Number(r.getAttribute('data-fixed')) || 0;
            var full = price * qty, total = fixed > 0 ? fixed : full;
            qs(card, '[data-ezp-total]').textContent = money(total, cfg.moneyFormat);
            qs(card, '[data-ezp-each]').textContent = money(Math.floor(total / qty), cfg.moneyFormat) + '/ea';
            var fullEl = qs(card, '[data-ezp-full]');
            fullEl.textContent = money(full, cfg.moneyFormat);
            fullEl.hidden = !(full > total);
          });
        });
      }

      form.addEventListener('submit', function (e) {
        if (!drawer) return; // No drawer: let the form post to /cart/add as normal.
        e.preventDefault();
        var picked = qs(form, '[data-ezp-bundle]:checked');
        var qty = picked ? Number(picked.value) : 1;
        button.disabled = true;
        button.classList.add('is-loading');
        if (sticky) sticky.busy(true);
        errorEl.hidden = true;
        request(cfg.routes.add + '.js', { items: [{ id: Number(idInput.value), quantity: qty }] })
          .then(function () { return drawer.refresh(); })
          .then(function () { drawer.open(button); })
          .catch(function (err) {
            errorEl.textContent = err.message || cfg.text.error;
            errorEl.hidden = false;
          })
          .then(function () {
            button.disabled = false;
            button.classList.remove('is-loading');
            if (sticky) sticky.busy(false);
          });
      });
    }

    function init(root) {
      if (root.__ezpReady) return;
      root.__ezpReady = true;
      var cfgEl = qs(root, '[data-ezp-config]');
      if (!cfgEl) return;
      var cfg = JSON.parse(cfgEl.textContent);
      var drawer = cfg.drawer ? createDrawer(root, cfg) : null;
      initGallery(root);
      initBuyBox(root, cfg, drawer);
      startCountdown(cfg, [root, drawer && drawer.el]);
      if (drawer && cfg.takeover) takeOverThemeCart(drawer);
    }

    function boot(scope) { qsa(scope || document, '[data-ezp-root]').forEach(init); }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
    else boot();

    document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
    document.addEventListener('shopify:section:unload', function (e) {
      var root = qs(e.target, '[data-ezp-root]');
      if (!root) return;
      var id = root.getAttribute('data-section-id');
      clearInterval(timers[id]);
      qsa(document.body, ':scope > [data-ezp-drawer="' + id + '"], :scope > [data-ezp-sticky="' + id + '"]').forEach(function (d) { d.remove(); });
      document.documentElement.classList.remove('ezp-lock');
      document.body.classList.remove('ezp-has-sticky');
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
